<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row dense>
              <v-col cols="12" md="9" sm="12">
                <h1 class="headline"> <strong>Instruksi</strong> Pemeriksaan </h1>
              </v-col>
              <v-col cols="12" md="3" sm="12" class="text-md-right">
                <v-chip :color="$getDeepObj(detail, 'status.color')" dark>
                  {{ $getDeepObj(detail, 'status.keterangan') }}
                </v-chip>
              </v-col>
            </v-row>
            <p>
              Anda perlu memeriksa keabsahan dokumen yang dikirimkan oleh para kandidat Peserta Diklat Komite Program
              Sekolah Penggerak, serta kesesuaiannya dengan data kandidat yang terekam oleh sistem
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <statistik v-if="false" :value="statistik"></statistik>
    <v-card flat class="mb-5">
      <v-card-text>
        <v-list-item class="px-0">
          <v-list-item-content>
            <v-row>
              <v-col class="py-0" cols="12" md="5">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-home</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 mt-3">
                    <h2 class="subtitle-1 black--text">
                      {{ $getDeepObj(detail, 'sekolah.data.nama') || '-' }}
                    </h2>
                    <p class="caption">
                      <span>
                        <v-icon small left>mdi-map-marker</v-icon>
                        {{
                          ($getDeepObj(detail, 'instansi.data.nama') || '-') +
                            ' - ' +
                            ($getDeepObj(detail, 'sekolah.data.m_propinsi.data.keterangan') || '-')
                        }}
                      </span>
                      <br />
                      <span>
                        <v-icon small left>mdi-city</v-icon>
                        {{ $getDeepObj(detail, 'sekolah.data.m_jenjang.data.singkat') || '-' }}
                      </span>
                    </p>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col class="pt-0" cols="12" md="3">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption">Kepala Sekolah</span>
                        <p class="ma-0">
                          <span>{{ $getDeepObj(detail, 'ptk_kasek.data.nama') || '-' }}</span>
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0" v-if="$getDeepObj(detail, 'ptk_id_wakasek')">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption">Wakasek Kurikulum SMK</span>
                        <p class="ma-0">
                          <span>{{ $getDeepObj(detail, 'ptk_wakasek.data.nama') || '-' }}</span>
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col class="py-0" cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item class="px-0">
                      <v-list-item-content class="py-0 mt-3">
                        <span class="caption">Pengawas Sekolah</span>
                        <p class="ma-0">
                          <span>{{ $getDeepObj(detail, 'psp_diklat_pengawases.data.0.ptk.data.nama') || '-' }}</span>
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-text class="pt-0">
        <v-toolbar flat>
          <v-toolbar-title class="body-1">Daftar Peserta Guru</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-divider />
        <!--List-->
        <base-list-table
          :hideHeader="true"
          :loading="false"
          :item="$getDeepObj(detail, 'psp_diklat_gurus.data') || []"
          :total="($getDeepObj(detail, 'psp_diklat_gurus.data') || []).length || 0"
          :usePaging="false"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Mata Pelajaran</span>
                          <p>
                            <span>{{ $getDeepObj(item, 'm_mapel_psp.data.keterangan') || '-' }}</span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="3">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Status</span>
                          <p>
                            <span>
                              {{ $isObject($getDeepObj(item, 'ptk.data.ptk_sekolah')) ? 'Satminkal' : 'Non Satminkal' }}
                              -
                              {{ $getDeepObj(item, 'ptk.data.m_pegawaidata.is_pns') ? 'PNS' : 'Non PNS' }}
                            </span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="py-0" cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0 mt-3">
                          <span class="caption">Nama Peserta</span>
                          <p>
                            <span>{{ $getDeepObj(item, 'ptk.data.nama') || '-' }}</span>
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
        <v-alert text color="info" v-if="mode === 'form'">
          <h3 class="title">
            <b>Informasi Tambahan:</b>
          </h3>
          <div>
            Setelah Anda memeriksa kelengkapan dokumen ini, silahkan tekan tombol <b>SIMPAN</b> pada pojok kanan atas
            layar Anda.
          </div>
        </v-alert>

        <v-row no-gutters dense :class="{ 'mt-3': mode === 'form' }">
          <v-col cols="12" md="1" sm="12" style="text-align: center">
            <v-avatar tile rounded>
              <v-icon size="50">mdi-file-document-edit-outline</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="12" md="11" sm="12">
            <div class="black--text my-2 ml-1">
              <h3>Pemeriksaan Peserta Diklat</h3>
              Berikan Penilaian pada kelengkapan dan keabsahan dokumen ini, Apakah semua dokumen sah dan sesuai dengan
              data yang di inputkan kandidat?
            </div>
            <v-card flat :disabled="mode !== 'form'">
              <v-row dense>
                <template v-for="item in mBtnPilihan">
                  <v-col :key="item.value" cols="12" md="4" class="my-auto">
                    <v-btn
                      block
                      :color="item.color"
                      :outlined="pilihan !== item.value"
                      :disabled="!item.akses"
                      @click="onSelected(item.value)"
                      style="background-color: white"
                    >
                      <v-icon small left>{{ item.icon }}</v-icon
                      >{{ item.label }}
                    </v-btn>
                  </v-col>
                </template>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" :class="{ 'mt-3': mode === 'form' }">
            <template v-if="mode === 'form'">
              <div class="pa-4" v-if="$isObject(schema[pilihan])">
                <b class="black--text">{{ schema[pilihan]['label'] }} *</b><br />
                <validation-provider
                  mode="passive"
                  :name="schema[pilihan]['label']"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    name="alasan"
                    :label="schema[pilihan]['label']"
                    required
                    v-model="form['alasan']"
                    :error-messages="errors"
                    rows="1"
                    single-line
                    outlined
                  />
                </validation-provider>
              </div>
            </template>
            <template v-else>
              <b class="black--text">Catatan Verval*</b><br />
              <v-card flat outlined>
                <v-card-text v-html="form['alasan']"></v-card-text>
              </v-card>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <base-modal-full ref="modal" :mode="'detail'" title="Detail Peserta Diklat">
      <v-card class="mx-auto" flat>
        <v-card-text>
          <v-container>
            <h2 class="mb-3">
              Daftar Peserta Diklat Sekolah
              <span class="secondary--text">{{ $getDeepObj(peserta, 'nama') || '' }} </span>
            </h2>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr style="background-color: #eeeeee">
                    <th class="text-left body-2 font-weight-bold px-0">
                      <v-row no-gutters class="pa-2">
                        <v-col cols="12" md="6">Mapel</v-col>
                        <v-col class="d-none d-sm-flex" cols="12" md="6">Guru</v-col>
                      </v-row>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in $getDeepObj(peserta, 'psp_diklat_gurus.data')" :key="i">
                    <td class="px-0">
                      <v-row no-gutters class="pa-2">
                        <v-col cols="12" md="6">
                          <span>{{ $getDeepObj(item, 'm_mapel_psp.data.keterangan') || '-' }}</span>
                        </v-col>
                        <v-col cols="12" md="6">
                          <span>{{ $getDeepObj(item, 'ptk.data.nama') || '-' }}</span>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-card-text>
      </v-card>
    </base-modal-full>
  </div>
</template>
<script>
import Statistik from '@/views/instansi/verval/component/Statistik';
import { ValidationProvider } from 'vee-validate';
import BaseListTable from '@components/base/BaseListTable';
import { mapActions } from 'vuex';
export default {
  name: 'FormVerval',
  components: { BaseListTable, Statistik, ValidationProvider },
  props: {
    masters: {
      default: () => {},
    },
    detail: {
      default: () => {},
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    statistik: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    mode: {
      type: String,
      default: 'form',
    },
    type: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      view: {},
      pilihan: null,
      search: null,
      peserta: {},
      form: {},
    };
  },

  computed: {
    schema() {
      return {
        4: {},
        5: {
          label: 'Alasan ajuan butuh diperbaiki',
        },
      };
    },

    mBtnPilihan() {
      return [
        {
          label: 'Diterima',
          icon: 'mdi-check',
          color: 'success',
          value: 4,
          akses: true,
        },
        {
          label: 'Perbaikan',
          icon: 'mdi-pencil',
          color: 'warning',
          value: 5,
          akses: +this.$getDeepObj(this.detail, 'gelombang_profil') === 1,
        },
      ];
    },
  },

  methods: {
    ...mapActions('diklat', ['getDetailSekolah']),

    getValue() {
      return { pilihan: this.pilihan, id: this.id, alasan: (this.form && this.form.alasan) || '' };
    },

    reset() {
      this.pilihan = null;
      this.$set(this, 'form', {});
    },

    initForm(value) {
      this.$set(this, 'pilihan', (value && value.pilihan) || null);
      this.$set(this.form, 'alasan', (value && value.alasan) || '');
    },

    onSelected(value) {
      // set
      this.$set(this, 'pilihan', value);
    },

    onListPeserta(item) {
      const id = item.sekolah_id;
      const type = this.type;

      this.getDetailSekolah({ id, type }).then(({ data }) => {
        this.peserta = data || {};
        this.$refs.modal.open();
      });
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
